import { kebabCase } from 'lodash'
import containers from './containers'
import core from './core'
import ui from './ui'

// Partials
import SeoFields from './forms/System/SeoFields'
import AddressFields from './forms/Geo/AddressFields'
// Vendors
import multiselect from 'vue-multiselect'
import draggable from 'vuedraggable'
import { Chrome } from 'vue-color'

// /**
//  * Components
//  * @type {Object}
//  */
const components = {
  ...containers,
  ...core,
  ...ui,

  // Partials
  'seo-fields': SeoFields,
  'address-fields': AddressFields,

  // Vendor
  multiselect,
  draggable,
  'color-picker': Chrome
}

function install (Vue) {
  Object.keys(components).forEach((directive) => {
    Vue.component(kebabCase(directive), components[directive])
  })
}

export default install



// WEBPACK FOOTER //
// ./src/components/index.js